// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__0qd3q","content":"modal_content__+aAt7"};